module.exports = __webpack_public_path__ + "img/ai-img-fyb.96b86bdf.png";